import { Component } from '@angular/core';
import { AddIcon } from '../../../../shared/ui/icons/add-icon/add-icon';
import { BankAccountsList } from '../../../../components/admin-dashboard-component/bank-account/bank-accounts-list/bank-accounts-list';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-list-bank-accounts',
  imports: [AddIcon, BankAccountsList, RouterLink],
  templateUrl: './list-bank-accounts.html',
  styleUrl: './list-bank-accounts.scss',
})
export class ListBankAccounts {}
